import { Component, ViewChild } from '@angular/core';;
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';
import * as FileSaver from 'file-saver';
import * as _ from 'lodash';
import * as html2pdf from 'html2pdf.js';
import { MatDialog } from '@angular/material';
import { Subject } from "rxjs/Subject";
import { BrowserModule, DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import 'rxjs/Rx';
import { fuseAnimations } from '../../../../../../../core/animations';

/**Pipe file */
import { CapitalizePipe } from '../../../../pipesFiles/capitalize.pipe';

// service file
import { EcommerceOrderService } from '../../../order/order.service';
import { EcommerceOrdersService } from '../../orders.service';
import { SolutionFormService } from '../../../solutionForm/solutionForm.service';

import { spekwo, order, spekWalk, displayValues, spekwoType } from '../../../../utils/index';
// Query file
import { ReportReviewQueryService } from '../../../../queryFiles/index';

// Local files
import { printDialogComponent } from '../../../printDialog/printDialog.component';
import { ToggledListComponent } from '../../../solutionForm/spekwo-type/after-client-accept-list/toggled-list/toggledList.component';

@Component({
    selector: 'request-work',
    templateUrl: './request-work.component.html',
    styleUrls: ['./request-work.component.scss'],
    animations: fuseAnimations,
    providers: [
        CapitalizePipe
    ],
})

export class RequestWorkComponent {

    orderValues = order;
    displayValues = displayValues;

    displayedColumns = ['name', 'solution', 'totalCost'];
    spekwoType = spekwoType;
    spekWalk = spekWalk;
    spekwoValues = spekwo;

    @ViewChild(ToggledListComponent) print: ToggledListComponent;

    dialogRef: any;
    orderType: string;
    public allReviewReports: any[] = [];
    public acceptedReports: any[] = [];

    selectedOrder: any = {};
    public unsubscribe = new Subject<void>();
    allSolutionEstimate = [];
    chunkArray = [];

    orderId: number;
    insReportId: string;
    buyerProperty: string;
    fullName: string;
    agent: string;
    clientName: string;
    forTotalCost: number = 0; // total cost after saving - admin given

    pdfUrl: SafeResourceUrl;

    currentpdfUrl: string;
    ishasAttachment: boolean = false;
    isAttachmentLoading: boolean = false;
    isShow: boolean = false;
    isClientAccept: boolean = false;

    pdfLinkFromCheckoutSubscription: Subscription;
    currentOrderPdfFinalLinkSubscription: Subscription;
    totalJobValue: any;
    type: string;
    currentOrderId: number;

    currentOrderChangedSubscription: Subscription;
    insReportIdChangeSubscription: Subscription;
    orderTypeChangeSubscription: Subscription;
    buyerPropertyChangesSubscription: Subscription;
    clientRoleChangeSubscription: Subscription;
    clientNameSubscription: Subscription;


    constructor(
        public route: ActivatedRoute,
        private location: Location,
        public dialog: MatDialog,
        private sanitizer: DomSanitizer,

        /** Pipe file */

        public capitalizePipe: CapitalizePipe,
        /** Service file */
        private orderService: EcommerceOrderService,
        private solutionFormService: SolutionFormService,
        public ecommerceOrdersService: EcommerceOrdersService,

        /** Query file */
        public reportReviewQueryService: ReportReviewQueryService

    ) {


    }
    ngOnInit() {

        // get current order from params
        this.route.params.subscribe(params => {
            this.currentOrderId = params.id;
        });

        //all review Details from stored details
        this.getAllStoredReports();

        //Check order type
        this.getOrder();

        this.currentOrderChangedSubscription =
            this.solutionFormService.currentOrderChanged.subscribe(res => {

                if (res) {
                    this.fullName = res.billing.first_name + ' ' + res.billing.last_name;
                }

            })

        /**Inspection id  */
        this.insReportIdChangeSubscription =
            this.solutionFormService.insReportIdChange.subscribe(insRes => {
                this.insReportId = insRes && insRes.insReportId;
            })

        /**Order type */
        this.orderTypeChangeSubscription =
            this.solutionFormService.orderTypeChange.subscribe(typeRes => {
                this.orderType = typeRes;
            })

        /**Buyer property */

        this.buyerPropertyChangesSubscription =
            this.solutionFormService.buyerPropertyChanges.subscribe(propertyRes => {
                this.buyerProperty = propertyRes;
            })

        /**Client  Name -not billing name .Its separate field */
        this.clientNameSubscription =
            this.solutionFormService.clientNameChange.subscribe(data => {
                if (data != undefined) {
                    this.clientName = data && data.name;
                }
            })
        /**Client  role */
        this.clientRoleChangeSubscription =
            this.solutionFormService.clientRoleChange.subscribe(roleRes => {
                this.agent = this.spekwoValues[roleRes];
            })

        //Pdf file link for new order.
        this.pdfLinkFromCheckoutSubscription =
            this.solutionFormService.pdfLinkFromCheckout.subscribe(checkRes => {
                // console.log('pdfLinkFromCheckoutSubscription', checkRes)

                if (!checkRes.loading) {
                    var attachmentId = this.currentOrderId - 1;
                    this.isAttachmentLoading = true;
                    this.ecommerceOrdersService.getAttachmentdata1(attachmentId, this.currentOrderId, checkRes.data);
                }
            })

        this.currentOrderPdfFinalLinkSubscription =

            this.ecommerceOrdersService.currentOrderPdfFinalLink.subscribe(res => {
                // console.log('currentOrderPdfFinalLink', res);
                if (!res.loading) {
                    this.ishasAttachment = res.data.isOrderHasAttachment;
                    this.currentpdfUrl = res.data.currentOrderAttachLink;
                    this.pdfUrl = res.data.currentOrderAttachLink;
                    this.isAttachmentLoading = false;
                } else {
                    this.isAttachmentLoading = true;
                    this.ishasAttachment = false;
                    this.pdfUrl = '';
                    this.pdfUrl = '';
                }
            })
    }
    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
        this.currentOrderPdfFinalLinkSubscription.unsubscribe();
        this.pdfLinkFromCheckoutSubscription.unsubscribe();
        this.currentOrderChangedSubscription.unsubscribe();
        this.insReportIdChangeSubscription.unsubscribe();
        this.orderTypeChangeSubscription.unsubscribe();
        this.buyerPropertyChangesSubscription.unsubscribe();
        this.clientRoleChangeSubscription.unsubscribe();
        this.clientNameSubscription.unsubscribe();
    }
    getAllStoredReports() {
        this.isShow = true;

        this.reportReviewQueryService
            .GET_All_STORED_REPORTS(this.currentOrderId)
            .takeUntil(this.unsubscribe)
            .subscribe((response: any) => {

                this.allReviewReports = [];

                if (response.data.allReportReviewDetails.edges.length > 0) {

                    response.data.allReportReviewDetails.edges.forEach((review, key) => {

                        this.allReviewReports.push({
                            name: review.node.subCategoryName ? review.node.categoryName ? review.node.categoryName + ':' + review.node.subCategoryName : review.node.subCategoryName : review.node.categoryName,
                            categoryId: review.node.categoryId,
                            subCategoryId: review.node.subCategoryId,
                            reviewId: review.node.reviewId,
                            id: review.node.id,
                            description: review.node.description,
                            totalCost: review.node.totalCost,
                            solution: review.node.solution,
                            reviewNodeId: review.node.nodeId,
                            imagePath: review.node.imagePath,
                            solCategory: review.node.solCategory,
                            solSubCategory: review.node.solSubCategory,
                            insReportId: review.node.insReportId,
                            approve: review.node.approve,
                            summary: review.node.solution,
                            itemNumber: review.node.itemNumWc,
                            mainCategory: review.node.categoryName,
                            subCategory: review.node.subCategoryName
                        });
                        //calculating total cost
                        this.forTotalCost = Number(this.forTotalCost) + Number(review.node.totalCost);


                    })
                    if (response.data.allReportReviewDetails.edges.length == this.allReviewReports.length) {
                        this.isShow = false;
                        this.allSolutionEstimate = this.allReviewReports;
                    }
                } else {
                    this.isShow = false
                }

            })
    }
    getOrder() {

        this.orderService.getOrder(this.currentOrderId)
            .then(() => {

                // 1.Subscribe to update order on changes -get current order details
                this.orderService.onOrderChanged
                    .subscribe(order => {

                        this.selectedOrder = order;

                        _.each(this.selectedOrder.line_items, item => {
                            this.orderType = this.spekwoValues[item.sku];
                        })

                    });
                this.type = (this.orderType == this.spekwoValues.HIQFULL ? 'spekwo' : 'walk-call')
            })
            .catch(() => {

            })
    }
    getTotalValue(totalJobValue) {
        this.totalJobValue = totalJobValue;
    }
    isClientAcceptSolution(isAccept) {
        this.acceptedReports = this.print && this.print.allIcReports;
        this.isClientAccept = isAccept;
    }

    // Solution estimate print - original solution estimate
    printDocument() {

        this.dialogRef = this.dialog.open(printDialogComponent, {
            panelClass: 'contact-form-dialog',
            data: {
                arrayData: this.allReviewReports,
                action: 'print',
                orderType: this.type
            }
        });

        this.dialogRef.afterClosed()
            .subscribe(response => {
                setTimeout(() => {
                });

            })

    }

    // Solution estimate print Requested solutions -Call another component function
    printValue() {
        console.log('this.acceptedReports', this.acceptedReports.length);
        this.print.printDocument();
    }

    // Solution estimate Requested solutions -download
    downloadDocument() {
        var element = document.getElementById('printForm');

        var name = this.capitalizePipe.transform(this.fullName);
        var buyerProperty = this.capitalizePipe.transform(this.buyerProperty);

        html2pdf(element, {
            margin: 1,
            filename: name + '-' + buyerProperty + '-' + 'Solution Estimation.pdf',
            image: { type: 'jpeg', quality: 1 },
            html2canvas: { useCORS: false, scale: 2 },
            jsPDF: { unit: 'cm', format: 'a2', orientation: 'p' },
            pagebreak: { mode: 'avoid-all', after: '.break-after', before: '.break-before' }
        });
    }

    downloadPdf() {
        // var pdfUrl = 'https://dev.api.spekwo.com/uploads//23176/1420 Rollingwood Inspection.pdf';

        this.ecommerceOrdersService.downalod1();

        this.ecommerceOrdersService.downloadPDF(this.pdfUrl).subscribe(
            (res) => {
                saveAs(res, "myPDF.pdf"); //if you want to save it - you need file-saver for this : https://www.npmjs.com/package/file-saver

                // var fileURL = URL.createObjectURL(res);
                // window.open(fileURL); // if you want to open it in new tab

            }
        );

    }

    openPdf() {
        window.open(this.currentpdfUrl, '_blank');
    }
}




// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/request-work/request-work.component.ts